import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlToggle extends BaseControl {
    constructor(pano: Pano) {
        super(pano, ControlPosition.LEFT);

        this.element.setAttribute("state", this._video.paused ? "paused" : "playing");
        this.element.classList.add("control-button", "toggle");
        this.element.innerHTML = `
        <div class="control-button-icon icon-420 play"></div>
        <div class="control-button-icon icon-421 pause"></div>
        `;

        var updateToggleBtn = () => {
            this.element.setAttribute("state", this._video.paused ? "paused" : "playing");
        };
        this._video.addEventListener("play", () => updateToggleBtn());
        this._video.addEventListener("playing", () => updateToggleBtn());
        this._video.addEventListener("pause", () => updateToggleBtn());
        this._video.addEventListener("loadstart", () => updateToggleBtn());
        this.element.addEventListener("click", (e) => {
            if (this._video.paused) {
                this.pano.play();
            }
            else
                this._video.pause();
        });
    }
}